import { ImpfstudienEntry } from '@/model/impfstudien';

import { DataFetcher } from './fetcher/DataFetcher/index.ts';
import { createEqualCommand, RepositoryNocoDbBase } from './repositoryNocoDbBase.ts';

export interface ImpfstudienSearchParams extends AbstractSearchParams {
  vaccine?: string;
  health_damage?: string;
  vaccine_manufacturer?: string;
  language?: string;
}

export class ImpfstudienRepository extends RepositoryNocoDbBase<ImpfstudienEntry, ImpfstudienSearchParams> {
  protected readonly TABLE_NAME = 'impfstudien';

  protected readonly API_ROUTE = `${process.env.API_URL}v2/noco/tables/${this.TABLE_NAME}/records`;

  protected readonly META_ROUTE = `${process.env.API_URL}v2/meta/tables/${this.TABLE_NAME}`;

  protected readonly DATE_FIELD = 'date_of_publication';

  protected readonly RELEVANCE_FIELD = 'rating';

  protected readonly STATIC_FILTER = createEqualCommand('publish', 'true');

  protected readonly SELECT_FILTERS: (keyof ImpfstudienEntry)[] = [
    'vaccine',
    'health_damage',
    'vaccine_manufacturer',
    'language'
  ];

  protected readonly SEARCH_FIELDS: (keyof ImpfstudienEntry)[] = [
    'abstract',
    'title',
    'health_damage',
    'vaccine_manufacturer',
    'vaccine',
    'author',
    'doi_number'
  ];

  public constructor(_fetcher: DataFetcher) {
    super(_fetcher);
  }
}
